<template>
    <section id="about"
             class="w-full h-screen bg-black snap-start w-full h-screen snap-start flex flex-col items-center justify-center">
        <Particles></Particles>
        <h2 class="text-2xl lg:text-5xl font-bold">About Me</h2>
        <div class="flex w-screen h-4/5 ">
            <div class="md:flex items-center justify-center w-screen">

                <div class="lg:w-1/3 md:text-2xl mx-20 lg:ml-0 ">
                    <div class="">
                        <h2>Bonjour tout le monde! <br/> Ici Benjamin AHO-NIENNE!</h2>
                        <p class="mb-0 md:mb-12">Je suis un Développeur Web Junior, je réside à la Réunion.
                            <br/>Je suis créatif, rigoureux et motivé. </p>

                        <div class="">
                            <div class="align-middle">
                                <ul>
                                    <li class="flex ">
                                        <span>
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 md:mt-1.5 mt-0" viewBox="0 0 20 20"
                                             fill="currentColor">
                                          <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"/>
                                          <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"/>
                                        </svg>
                                       </span>aho.benji@gmail.com
                                    </li>
                                    <li class="flex">
                                        <span>
<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd"
        d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
        clip-rule="evenodd"/>
</svg>
                                        </span>
                                        LeTampon 97430
                                    </li>
                                </ul>
                            </div>
                            <div class="">
                                <ul>
                                    <li class="flex">
                                        <span>
                                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 md:mt-1.5 mt-0"
                                                 viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 100-2 1 1 0 000 2zm7-1a1 1 0 11-2 0 1 1 0 012 0zm-.464 5.535a1 1 0 10-1.415-1.414 3 3 0 01-4.242 0 1 1 0 00-1.415 1.414 5 5 0 007.072 0z"
        clip-rule="evenodd"/>
                                            </svg>
                                        </span>27ans
                                    </li>
                                    <li class="flex">
                                        <span>
                                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 md:mt-1.5 mt-0" viewBox="0 0 20 20"
                                                 fill="currentColor">
  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"/>
</svg>
                                        </span>0764357251
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>
                <!--                PROGRESSBAR-->
                <div class="w-1/2 mx-20 lg:ml-0">

                    <div class="relative pt-1">
                        <div class="flex mb-2 items-center justify-between">
                            <div>
                                <span class="text-sm font-semibold inline-block py-1 px-2 uppercase rounded-full text-blue-600 bg-blue-200">
                                    HTML/CSS
                                </span>
                            </div>
                            <div class="text-right">
                                <span class="text-sm font-semibold inline-block text-blue-600">
                                    95%
                                </span>
                            </div>
                        </div>
                        <div class="overflow-hidden h-2 mb-4 text-sm flex rounded bg-blue-200">
                            <div style="width:95%"
                                 class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-blue-600"></div>
                        </div>
                    </div>

                    <div class="relative pt-1">
                        <div class="flex mb-2 items-center justify-between">
                            <div>
                              <span class="text-sm font-semibold inline-block py-1 px-2 uppercase rounded-full text-purple-600 bg-purple-200">
                                PHP
                              </span>
                            </div>
                            <div class="text-right">
                              <span class="text-sm font-semibold inline-block text-purple-400">
                                40%
                              </span>
                            </div>
                        </div>
                        <div class="overflow-hidden h-2 mb-4 text-sm flex rounded bg-purple-200">
                            <div style="width:40%"
                                 class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-purple-400"></div>
                        </div>
                    </div>

                    <div class="relative pt-1">
                        <div class="flex mb-2 items-center justify-between">
                            <div>
                              <span class="text-sm font-semibold inline-block py-1 px-2 uppercase rounded-full text-yellow-600 bg-yellow-200">
                                JavaScript
                              </span>
                            </div>
                            <div class="text-right">
                              <span class="text-sm font-semibold inline-block text-yellow-600">
                                60%
                              </span>
                            </div>
                        </div>
                        <div class="overflow-hidden h-2 mb-4 text-sm flex rounded bg-yellow-200">
                            <div style="width:60%"
                                 class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-yellow-600"></div>
                        </div>
                    </div>

                    <div class="relative pt-1">
                        <div class="flex mb-2 items-center justify-between">
                            <div>
                              <span class="text-sm font-semibold inline-block py-1 px-2 uppercase rounded-full text-purple-900 bg-purple-200">
                                Bootstrap/Tailwind
                              </span>
                            </div>
                            <div class="text-right">
                              <span class="text-sm font-semibold inline-block text-purple-700">
                                50%
                              </span>
                            </div>
                        </div>
                        <div class="overflow-hidden h-2 mb-4 text-sm flex rounded bg-purple-200">
                            <div style="width:50%"
                                 class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-purple-900"></div>
                        </div>
                    </div>

                    <div class="relative pt-1">
                        <div class="flex mb-2 items-center justify-between">
                            <div>
                              <span class="text-sm font-semibold inline-block py-1 px-2 uppercase rounded-full text-pink-600 bg-red-200">
                                Java
                              </span>
                            </div>
                            <div class="text-right">
                              <span class="text-sm font-semibold inline-block text-red-600">
                                20%
                              </span>
                            </div>
                        </div>
                        <div class="overflow-hidden h-2 mb-4 text-sm flex rounded bg-red-200">
                            <div style="width:20%"
                                 class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-red-500"></div>
                        </div>
                    </div>

                </div>

            </div> <!-- End Row -->
        </div>
    </section>
</template>

<script>
    import Particles from "../components/Particles.vue";

    export default {
        name: "aboutSection",
        components: {Particles},
    }
</script>

<style scoped>
    #particles-js {
        position: absolute;
        width: 100%;
        height: 100%;
    }
</style>